"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const svgs_1 = require("@@/assets/svgs");
const Button_1 = __importDefault(require("@mui/material/Button"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
function default_1({ recordField, uploadRecordFile, isUploadingFile, }) {
    const uploadInputId = `record_file_uploader_${recordField}`;
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ disabled: isUploadingFile, component: "label", sx: {
            columnGap: '4px',
            minWidth: '78px',
            height: '28px',
            p: '0 8px',
            borderRadius: '6px',
            border: '1px solid var(--gray-10)',
            fontSize: '15px',
            color: 'var(--gray-80)',
            bgcolor: 'var(--white) !important',
        } }, { children: [(0, jsx_runtime_1.jsx)("input", { id: uploadInputId, name: "file", type: "file", hidden: true, onChange: e => {
                    if (e.target.files) {
                        uploadRecordFile(e.target.files);
                    }
                }, onClick: e => {
                    (0, webview_app_1.askPhotoPermissionsToWVA)(uploadInputId, e);
                    e.currentTarget.value = '';
                } }), isUploadingFile ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 12, color: "secondary", thickness: 6 })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(svgs_1.UploadIconSvg, {}), (0, jsx_runtime_1.jsx)("span", { children: t('올리기') })] }))] })));
}
exports.default = default_1;
